import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';

import { TreeSelectionModel } from './tree-selection.model';
import { FilterItemsService } from './filter-items.service';
import { MediationFilters } from "../mediation/mediation.filters";
import { consts } from "./consts";
import { StorageService } from "../core/services/index";

@Component({
    selector: 'publishers-tree-selection-modal',
    templateUrl: 'publishers-tree-selection-modal.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PublisherTreeSelectionModalComponent implements OnInit {
    values: Array<TreeSelectionModel> = new Array<TreeSelectionModel>();
    itemsSelectedCount: number = 0;

    @Output()
    valueChange: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();

    constructor(
        private storageService: StorageService,
        private filterItemsService: FilterItemsService) {
        this.values = this.values || new Array<TreeSelectionModel>();
    }

    ngOnInit() {
        this.values = this.filterItemsService.getPublishers().sort((p1,p2) => p1.group.toLowerCase() > p2.group.toLowerCase() ? 1 : -1);
        let publisherFromStorage = this.storageService.get(consts.PublisherIdsFilterStorageKey);
        let mediationFilter = <MediationFilters>this.storageService.get(consts.MediationFilterStorageKey);
        if (publisherFromStorage || mediationFilter) {
            if (publisherFromStorage) {
                let items = <Array<Number>>publisherFromStorage;
                this.values.forEach(s => s.isSelected = null);
                let _values = this.values.filter(s => items.indexOf(s.value) > -1);
                _values.forEach(s => s.isSelected = true);
            }
            if (mediationFilter) {
                this.values.forEach(s => s.isSelected = null);
                let item = this.values.find(s => s.value === mediationFilter.publisherId);
                item.isSelected = true;
            }
        }
        this.itemsSelectedCount = $("#publishers-select").next().find("[class='selected']").find("[class='item']").length;
        setInterval(() => {
            this.itemsSelectedCount = $("#publishers-select").next().find("[class='selected']").find("[class='item']").length;
        }, 300);
    }

    onApplyFilter(event) {
        let items = $("#publishers-select").next().find("[class='selected']").find("[class='item']");
        let result = Array<number>();
        if (items)
            for (var i = 0; i < items.length; i++) {
                result.push($(items[i]).data("value"));
            }

        if (result.length !== 0) {
            $('#treePublishersFilter').modal('hide');
            this.valueChange.emit(result);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/publishers-tree-selection-modal.component.ts